export default __webpack_public_path__ + "9acd04365eab38afebada3074c3ad912.png";